// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GZav","imgBg":"GZabf","image":"GZob","title":"GZal","statistic":"GZa5"};